import React from "react";
import SampleContactList from "../components/SampleContact";

const SampleApi = () => {
  return (
    <div className="SampleApi">
      <h1>샘플 API</h1>
      <hr />
      <SampleContactList />
    </div>
  );
};

export default SampleApi;
